import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { mapExportItemToDetails } from '@/features/DataHub/api/pastExports.api';
import { pastExportsOptions } from '@/features/DataHub/api/pastExports.options';

type UsePastExportDetailsOptions = {
  enabled?: boolean;
};

export const usePastExportDetails = (exportId: string, options?: UsePastExportDetailsOptions) => {
  const query = useQuery(pastExportsOptions.list());
  const { data: exports, isLoading, isError } = query;

  const data = useMemo(() => {
    if (!exports || !(options?.enabled ?? true)) return undefined;
    const item = exports.find(e => e.id === exportId);
    if (!item) return undefined;
    return mapExportItemToDetails(item);
  }, [exports, exportId, options?.enabled]);

  return {
    data,
    isLoading: isLoading && (options?.enabled ?? true),
    isError
  };
};
